import { styles } from "./Footer.style";
import * as React from "react";
import { Typography } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import { theme } from "../../theme/theme";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import DynamicIcon from "../Icons/DynamicIcon";

class Footer extends React.Component<WithStyles<typeof styles>> {

    public render() {

        const classes = this.props.classes;

        const socials = [
            { label: "Facebook", target: "https://www.facebook.com/AG2RLAMONDIALE/" },
            { label: "LinkedIn", target: "https://fr.linkedin.com/company/ag2r-la-mondiale" },
            { label: "ScoopIt",  target: "https://www.scoop.it/u/ag2rlamondiale" },
            { label: "Twitter",  target: "https://twitter.com/ag2rlamondiale" },
            { label: "Youtube",  target: "https://www.youtube.com/user/AG2RLAMONDIALE" }
        ];

        return (
            <div className={classes.background}>
                <div className={classes.container}>
                    <Toolbar className={classes.links}>
                        <Typography variant="caption"><a href="https://www.ag2rlamondiale.fr/">ag2rlamondiale.fr</a></Typography>
                        <Typography variant="caption"><a download={true} target="_blank" href={require("./conditions_generales_utilisation.pdf")}>Conditions générales d'utilisation</a></Typography>
                        {/*<Typography variant="caption">Cookies</Typography>*/}
                    </Toolbar>
                    <Toolbar className={classes.socials}>
                        {socials.map(social => (
                            <IconButton
                                aria-label={social.label}
                                className={classes.iconButton}
                                href={social.target}
                                key={social.label}
                                target="_blank"
                            >
                                <DynamicIcon name={social.label} suffix="Logo" nativeColor={theme.palette.primary.main} />
                            </IconButton>
                        ))}
                    </Toolbar>
                </div>
            </div>
        );

    }
}

export default withStyles(styles)(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx